module.exports = "<svg class=\"CounterControl-icon\" xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 16 2\"><path d=\"M0 0h16v2H0z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader!./client/components/CounterControl/minus.svg
// module id = 2001
// module chunks = 0